import React from 'react';
import PropTypes from 'prop-types';
import LineItem from './LineItem';
import Loading from '../Loading';
import Panel from 'wonderbly-components/lib/Panel';

import './CartItems.scss';

const CartItems = props => (
  <section className="cart-items">
    <div className="container-guttered">
      <h1 className="text-mega">{props.title}</h1>
      <div className="cart-items-inner">
        {props.items.map(item => (
          <Panel className="line-item" key={item.id}>
            <LineItem
              item={item}
              handleRemove={props.cart.remove}
              editItemCta={props.editItemCta}
              editGiftwrapCta={props.editGiftwrapCta}
              addGiftwrapCta={props.addGiftwrapCta}
              editExtrasCta={props.editExtrasCta}
              addExtrasCta={props.addExtrasCta}
              savingsPriceLabel={props.savingsPriceLabel}
              isEditable
              isRemovable
            />
          </Panel>
        ))}
        {props.isCartPending && <Loading dark />}
      </div>
    </div>
  </section>
);

CartItems.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  cart: PropTypes.object.isRequired,
  isCartPending: PropTypes.bool.isRequired,
  editItemCta: PropTypes.string.isRequired,
  editGiftwrapCta: PropTypes.string.isRequired,
  addGiftwrapCta: PropTypes.string.isRequired,
  editExtrasCta: PropTypes.string,
  addExtrasCta: PropTypes.string,
  savingsPriceLabel: PropTypes.string,
};

export default CartItems;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartItems/CartItems.js